module.exports = __webpack_public_path__ + "static/img/bcg_unit7.e65773ad.png";